import { Button, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_CONTAINER_FIELDS_FLOATING, LIGHT_CONTAINER_FIELDS_FLOATING } = COLORS;

export const AddRepresentativesButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  borderRadius: '8px',
  width: '100%',
  height: 151,
  position: 'relative',

  // this margin top 20 is for the primary tag space, so button is align with the items, dont remove it
  marginTop: 20,
}));
